export default {
  rewards: {
    title: "Rewards",
    claim: "Claim",
    weeklyCashback: "Weekly Cashback",
    weeklyCashbackDesc: "Get back a portion of your weekly losses every week.",
    dailySpin: "Daily Spin",
    dailySpinDesc: "Spin the wheel daily for a chance to win big prizes.",
    invitationBonus: "Invitation Bonus",
    invitationBonusDesc: "Invite friends and earn rewards for each one who joins.",
    rebate: "Rebate",
    rebateDesc: "Earn rebates on every bet you place, win or lose.",
    bannerTitle: "REWARDS",
    bannerSubtitle: "Complete tasks and earn amazing rewards!",
    sectionTitle: "Your Amazing Rewards",
    goNow: "Go Now",
    historyReceived: "History received",
    todayReceived: "Today received",
    cashbackDialog: {
      title: "Bet Cashback",
      loading: "Loading...",
      empty: "No cashback rules",
      level: "Level",
      amountRange: "Amount Range",
      rewardRate: "Reward Rate",
      rewardCap: "Reward Cap",
    },
    cards: {
      checkin: {
        title: "Daily Check in",
        subtitle: "Log in to check in daily",
        description: "Players, remember to sign in every day~",
      },
      cashback: {
        title: "Cashback",
        subtitle: "Platform rebate rewards",
      },
      rescue: {
        title: "Rescue Bonus",
        subtitle: "Play 3 cash games",
        description: "Rescue funds save bankrupt players",
      },
      task: {
        title: "Tasks",
        subtitle: "Complete platform tasks",
        description: "Platform tasks",
      },
      balance: {
        title: "Vault",
        subtitle: "Earn daily interest",
        description: "Platform Yu'E Bao",
      },
      loan: {
        title: "Loan Bonus",
        subtitle: "Borrow with ease",
        description: "Platform borrowing treasure",
      },
    },
    checkIn: {
      dailySignIn: "DAILY SIGN-IN",
      totalRewards: "TOTAL REWARDS",
      headlineDaysBefore: "Sign In for",
      headlineDaysAfter: "days,",
      headlineTailCumulative: "missing a day doesn't matter.",
      headlineTailDate: "missing a day forfeits that day's reward.",
      headlineCumulative: "Sign In for {days} days to win big, missing a day doesn't matter.",
      headlineDate: "Sign In for {days} days, missing a day forfeits that day's reward.",
      headlineEmpty: "Sign In to win rewards",
      title: "Check-in",
      modeCumulative: "Cumulative Check-in",
      modeDate: "Date Check-in",
      rewards: "Rewards",
      signedIn: "Signed in",
      day: "Day {n}",
      loading: "Loading...",
      empty: "No active check-in activity.",
      btnCheckIn: "Check In",
      btnSigned: "Signed In",
      btnLocked: "Locked",
      claimSuccess: "Check-in successful, reward {amount} {currency} credited",
      claimFailed: "Check-in failed",
      alreadySigned: "You have already signed in today",
      notLogin: "Please log in first",
    },
  },
};
